import { LitElement, html, css } from 'lit';
import { query, property, customElement } from 'lit/decorators.js';
import '../langhout-button/langhout-button';
import { showNotification } from '../../LanghoutBetonApp';
import { Product, RetourOrderProduct } from '../../types/types';
import { SearchDropdown } from '../search-dropdown/search-dropdown';

@customElement('edit-product')
export class EditProduct extends LitElement {
  static styles = css`
    :host {
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.1);
    }

    .row {
      display: flex;
      flex-direction: row;
    }

    .wrap-row {
      flex-wrap: wrap;
      flex-flow: row wrap;
    }

    .centered {
      justify-content: center;
      align-items: center;
    }

    .outer-wrapper {
      width: 100vw;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .wrapper {
      padding-top: 30px;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 40px;
      border-radius: 10px;
      background-color: var(--background-color);
      border: 1px solid var(--primary-color);
      display: flex;
      flex-direction: column;
      min-width: 60vw;
      max-width: calc(100vw - 60px);
    }

    input {
      padding: 7px;
      border-radius: 5px;
      font-size: 16px;
      width: 100px;
    }

    langhout-button {
      margin-top: 25px;
      width: 218px;
    }

    h2 {
      margin: 0px;
      margin-bottom: 30px;
    }

    .fill {
      flex-grow: 1;
    }

    search-dropdown {
      width: 450px;
    }

    .prod-search {
      width: 450px;
    }

    .label {
      margin-bottom: 10px;
      margin-top: 10px;
      text-align: left;
      font-weight: 900;
    }
  `;

  @query('#amount')
  public amountInput?: HTMLInputElement;

  @query('#selectedProduct')
  public selectedProduct?: SearchDropdown;

  @property({ type: Boolean, attribute: true, reflect: true })
  public isEdit = false;

  @property({ type: Object, attribute: true, reflect: true })
  public product: RetourOrderProduct | null = null;

  constructor() {
    super();
  }

  public focus = () => {
    if (this.amountInput) {
      this.amountInput.focus();
    }
  };

  render() {
    return html`
      <div class="outer-wrapper">
        <div class="row centered">
          <div class="wrapper">
            ${this.renderHeader()}
            <div class="row centered wrap-row">
              <div class="column">
                <div class="label">Stuks</div>
                <input
                  type="number"
                  .value="${this.product ? this.product.amount : ''}"
                  id="amount"
                  pattern="[0-9]*"
                  min="0"
                  name="amount"
                  placeholder="Aantal"
                />
              </div>
              <div class="fill"></div>
              <div class="column prod-search">
                <div class="label">Product</div>

                <search-dropdown
                  .isRetour="${true}"
                  id="selectedProduct"
                  .selected="${
                    this.product
                      ? <Product>{
                          id: this.product.id,
                          description: this.product.description,
                        }
                      : null
                  }"
                ></search-dropdown>
              </div>
            </div>
            <div class="row centered">${this.renderControlButton()}</div>
            <div class="row centered">
              <langhout-button
                reverse
                text="Annuleren"
                @click="${() => {
                  this.dispatchCloseEvent();
                }}"
              ></langhout-button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderHeader() {
    if (this.isEdit) {
      return html` <h2>Product aanpassen</h2> `;
    }
    return html` <h2>Product toevoegen</h2> `;
  }

  renderControlButton() {
    if (this.isEdit) {
      return html`
        <langhout-button
          text="Product aanpassen"
          @click="${() => {
            this.editProduct();
          }}"
        ></langhout-button>
      `;
    }
    return html`
      <langhout-button
        text="Product toevoegen"
        @click="${() => {
          this.editProduct();
        }}"
      ></langhout-button>
    `;
  }

  editProduct = () => {
    const amountString = this.amountInput ? this.amountInput.value : '';
    if (amountString === '') {
      showNotification('Aantal stuks kan niet leeg zijn');
      return;
    }
    const amount = parseInt(amountString);
    if (amount <= 0) {
      showNotification('Aantal moet groter zijn dan 0');
      return;
    }
    if (!this.selectedProduct || !this.selectedProduct.selected) {
      showNotification('Product kan niet leeg zijn');
      return;
    }
    this.dispatchCloseWithvaluesEvent(amount, this.selectedProduct.selected.id);
    if (this.amountInput) {
      this.amountInput.value = '';
    }
    if (this.selectedProduct) {
      this.selectedProduct.selected = undefined;
    }
  };

  dispatchCloseWithvaluesEvent = (amount: number, id: string) => {
    const old_id = this.product ? this.product.id : '';
    const event = new CustomEvent('close', {
      detail: {
        amount,
        id,
        old_id,
      },
    });
    this.dispatchEvent(event);
  };

  dispatchCloseEvent = () => {
    const event = new CustomEvent('close', {
      detail: {},
    });
    this.dispatchEvent(event);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'edit-product': EditProduct;
  }
}
